<template>
  <div class="community-page">
    <el-tabs v-model="community">
      <el-tab-pane label="整体情况" name="whole">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="wholeForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="wholeForm.way" @change="getWholeList">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('goodsType')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.sMonth" type="month" placeholder="选择日期" class="width-z100"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="wholeForm.eMonth" placeholder="选择日期" type="month"
                                @change="getWholeList(wholeTime = 2)" :picker-options="pickerOptions"
                                class="width-z100" size="small" format="yyyy-MM"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30">
          <el-row>
            <el-col :span="14">
              <chart ref="chart1" :options="options" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="9" class="margin-l-30">
              <el-table :data="wholeTable" stripe class="colorChang border-DEDEDE" height="380">
                <el-table-column prop="times" label="时间" width="100px" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>

      </el-tab-pane>
      <el-tab-pane label="渠道分析" name="platform">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="platformForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="platformForm.way" @change="getPlatformList">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="platformTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="oneMonth()">近1个月</span>
                <span :class="platformTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>

              <el-col :span="4">
                <el-date-picker v-model="platformForm.eMonth" placeholder="选择日期" type="month"
                                @change="getPlatformList(platformTime = 2)" :picker-options="pickerOptions"
                                class="width-z100" size="small" format="yyyy-MM"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-form>
        </el-card>

        <div class="margin-t-30 margin-b-20 margin-l-30  community-bottom margin-r-30">
          <el-row>
            <el-col :span="12" class="padding-r-20 community-bottom-three">
              <el-card class="height-z100">
                <chart ref="chart4" :options="platformPieOptions" autoresize class="width-z100 margin-t-40"></chart>
              </el-card>
            </el-col>
            <el-col :span="12" class="community-bottom-three">
              <el-card>
                <chart ref="chart1" :options="orgOptions" autoresize class="width-z100 margin-t-40"
                       style="height: 530px"></chart>
              </el-card>
            </el-col>
          </el-row>

        </div>
      </el-tab-pane>
    </el-tabs>
    <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A margin-t-20">注：<BR/>
      1.社区电商网络零售额统计范围为目前在江西形成一定规模的社区电商平台，如兴盛优选、小区乐等<br/>
      2.社区电商渠道分析为目前已覆盖九江市的社区电商平台
    </p>

  </div>
</template>

<script>
  export default {
    name: 'community',
    data () {
      return {
        community: 'whole',
        options: {}, //整体情况柱状图
        wholeTitle: '',//整体情况柱状图标题
        wholeList: {xTime: [], yTotalmoney: [], simple: []},//整体情况图标所需数据组装
        wholeTable: [],//整体情况表格
        wholeForm: {way: '当期网络零售额', sMonth: '', eMonth: ''},//整体情况筛选条件
        wholeTime: '1',
        platformForm: {way: '当期网络零售额', eMonth: ''},
        platformPieOptions: {},//社区电商平台占比图
        platformTime: '1',
        platformList: {name: [], data: []},//社区电商平台所需数据组装

        orgOptions: {},
        goodsTopList: [],
        // numberList:{city:[]}
        items: [
          {type: 'danger', label: 'Top1'},
          {type: 'success', label: 'Top2'},
          {type: 'brand ', label: 'Top3'},
          {type: 'info', label: 'Top4'},
          {type: 'info', label: 'Top5'},
          {type: 'info', label: 'Top6'},
          {type: 'info', label: 'Top7'},
          {type: 'info', label: 'Top8'},
          {type: 'info', label: 'Top9'},
          {type: 'info', label: 'Top10'}
        ],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }

    },

    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      // this.oneMonth()
      this.twelveMonth()
      this.oneMonth()
    },
    methods: {
      //整体情况列表
      getWholeList () {
        if (this.wholeForm.type == '1') {
          this.wholeTitle = '当期网络零售额'
        } else {
          this.wholeTitle = '累计网络零售额'
        }
        this.$http.get(this.header + '/community/xyWhole', {
          params: {
            index_type: this.wholeForm.way,
            sMonth: this.wholeForm.sMonth,
            eMonth: this.wholeForm.eMonth,
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.wholeList = {xTime: [], yTotalMoney: [], simple: [], simpleUnit: []},


            res.data.list.forEach((y, index) => {
              this.wholeList.xTime.push(y.times)
              if(y.absoulte_value_yoy == null){
                y.absoulte_value_yoy = '--'
              }
              let yMoney = {
                value: y.absoulte_value,
                unit: y.absoulte_key
              }
              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              this.wholeList.simple.push(xSimple)
              this.wholeList.yTotalMoney.push(yMoney)
              // this.wholeList.yTotalMoney.unit.push('万元')

              // this.wholeList.simpleUnit.push('%')
              // return label
            })
            this.wholeTable = res.data.list.reverse()
            let Min1 = this.calMin(this.wholeList.yTotalMoney), Min2 = this.calMin(this.wholeList.simple),
              Max1 = this.calMax(this.wholeList.yTotalMoney), Max2 = this.calMax(this.wholeList.simple)
            //整体情况图表
            this.options = {
              color: ['#7888ed', '#FB975B'],
              title: {//图表标题
                text: '社区电商' + this.wholeForm.way + '变化趋势',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                // trigger: 'axis',
                // axisPointer: {
                //   type: 'cross'
                // },
                formatter: function (e) {
                  // console.dir(e)
                  return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  // '{b}{a}<br/>{c} 万元'
                }
                // formatter: '{a} <br/>{b}: {c} ',
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line', 'bar']},
                  restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['销售额', '同比']
              },
              xAxis: {
                type: 'category',
                data: this.wholeList.xTime,
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '万元',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: Min1,
                  max: Max1,
                  splitNumber: 5,
                  interval: (Max1 - Min1) / 5
                }, {
                  type: 'value',
                  name: '%',
                  // min: 0,
                  // max: 35,
                  // interval: 5,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: Min2,
                  max: Max2,
                  splitNumber: 5,
                  interval: (Max2 - Min2) / 5,
                  axisLabel: {
                    formatter: '{value} %'
                  }
                }],
              series: [{
                name: '销售额',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {

                  emphasis: {
                    color: '#83bff6'
                  }
                },
                data: this.wholeList.yTotalMoney,
                smooth: true
              }, {
                name: '同比',
                type: 'line',
                yAxisIndex: 1,
                data: this.wholeList.simple
              }]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //渠道分析
      getPlatformList () {
        if (this.wholeForm.type == '1') {
          this.wholeTitle = '当期网络零售额'
        } else {
          this.wholeTitle = '累计网络零售额'
        }
        this.$http.get(this.header + '/community/cannal', {
          params: {
            index_type: this.platformForm.way,
            times: this.platformForm.eMonth
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.platformList = {name: [], data: []}
            res.data.platform.forEach((y, index) => {
              let platformData = {
                value: y.absoulte_value,
                name: y.absoulte_key
              }
              this.platformList.name.push(y.absoulte_key)
              this.platformList.data.push(platformData)
            })
            let distribution = []
            res.data.cover.forEach((x) => {
              let item = {
                name: x.district,
                value: x.platforms.length,
                cover: x.coverJson
              }
              distribution.push(item)
            })

            //社区电商平台占比图
            this.platformPieOptions = {
              color: ['#7888ed', '#FB975B', '#08F0A4', '#9C95FF', '#E4B872'],
              title: {//图表标题
                text: '各交易平台' + this.platformForm.way + '占比',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
                left: 'left'
              },
              tooltip: {
                trigger: 'item',
                formatter: '{b}: {d}%'
              },
              legend: {
                orient: 'horizontal',
                y: 'bottom',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: this.platformList.name
              },
              series: [
                {
                  name: '访问来源',
                  type: 'pie',
                  radius: ['50%', '70%'],
                  avoidLabelOverlap: false,
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold'
                      }
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data: this.platformList.data
                }
              ]
            }

            //江西社区电商平台分布情况
            this.orgOptions = {
              title: {//图表标题
                text:  '九江市主流社区电商渠道地图',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
                left: 'left'
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: function (e) {
                  return e.data.cover
                }
              },
              visualMap: {
                min: 0,
                max: 4,
                // text: ['High', 'Low'],
                // orient: 'horizontal',
                realtime: false,
                calculable: true,
                inRange: {
                  // color: ['rgba(218,228,258,1)', 'rgba(143,176,245,1)', 'rgba(68,124,238,1)']
                  color: ['#4b68c0', '#76fcff']
                  // color: ['rgba(218,228,258,1)', 'rgba(143,176,245,1)', 'rgba(68,124,238,1)']
                }
              },
              series: [
                {
                  name: '江西各地区数据统计',
                  type: 'map',
                  mapType: 'JJ', // 自定义扩展图表类型
                  // itemStyle: {
                  //   normal: {label: {show: true}},
                  //   emphasis: {label: {show: true}, areaColor: 'beige'}
                  // },
                  itemStyle: {
                    normal: {
                      label: {show: true, color: '#fff'},
                      areaColor: '#FB975B',
                      borderColor: '#76fcff',
                      borderWidth: 0.5,
                    },
                    emphasis: {
                      areaColor: '#f0e68c'
                    }
                  },
                  data: distribution
                  //   [
                  //   {name: '九江市', value: 3, shop: 5659},
                  //   {name: '南昌市', value: 3, shop: 5659},
                  //   {name: '景德镇市', value: 2, shop: 5659},
                  //   {name: '萍乡市', value: 1, shop: 5659},
                  //   {name: '新余市', value: 1, shop: 5659},
                  //   {name: '赣州市', value: 2, shop: 5659},
                  //   {name: '吉安市', value: 2, shop: 5659},
                  //   {name: '鹰潭市', value: 1, shop: 5659},
                  //   {name: '宜春市', value: 2, shop: 5659},
                  //   {name: '抚州市', value: 0, shop: 5659},
                  //   {name: '上饶市', value: 0, shop: 5659}
                  // ]

                }
              ]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },

      //选择近13个月
      twelveMonth (val) {

        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if(day > 14){
          this.wholeTime = '1'
          this.wholeForm.sMonth = dataArr[13]
          this.wholeForm.eMonth = dataArr[1]
        }else{
          this.wholeTime = '1'
          this.wholeForm.sMonth = dataArr[14]
          this.wholeForm.eMonth = dataArr[2]
        }
        this.getWholeList()
      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
      //选择近1个月
      oneMonth (val) {
        var dataArr = []
        var data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if(day > 14){
          this.platformTime = '1'
          this.platformForm.eMonth = dataArr[1]
        }else{
          this.platformTime = '1'
          this.platformForm.eMonth = dataArr[2]
        }
        this.getPlatformList()
      },
    }
  }
</script>

<style>


  .community-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
  }

  .community-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .community-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .community-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .community-page .el-form-item {
    margin-bottom: 0;
  }

  .community-page .community-header {
    line-height: 40px;
    background-color: #323740;
    color: white;
  }

  .community-page .community-header span {
    background-color: #3865A5;
    line-height: 40px;
    width: 180px;
    height: 45px;
    display: block;
    text-align: center;
  }

  .community-page .community-bottom .el-tag {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    border-radius: 20px;
  }

  .community-page .community-bottom .community-bottom-three {
    height: 608px;
  }

  .community-page .el-form-item {
    margin-bottom: 0;
  }

  .community-page .topicOne {
    background-color: #E76252;
    border-radius: 20px;
    height: 15px;
    line-height: 15px;
    width: 45px;
    padding: 0 8px;
    color: white;
    margin-top: 16px;
  }

  .community-page .topicTwo {
    background-color: #90AC4E;
    border-radius: 20px;
    height: 15px;
    line-height: 15px;
    width: 45px;
    padding: 0 8px;
    color: white;
    margin-top: 16px;
    /*margin-top: 15px;*/
  }

  .community-page .topicThree {
    background-color: #55ACEE;
    border-radius: 20px;
    height: 15px;
    line-height: 15px;
    width: 45px;
    padding: 0 8px;
    color: white;
    margin-top: 16px;
    /*margin-top: 15px;*/
  }



  .el-date-picker__header--bordered {
    border-bottom: solid 1px #D0D6DF;
  }

  /*.community-page .echarts,.community-page .echarts div,community-page .echarts div canvas{*/
  /*   width: 100% !important;*/
  /* }*/
</style>



// WEBPACK FOOTER //
// src/components/characteristic/community.vue